import COLORS from '../../utils/constants/colors'

const HPAD = 18
const VPAD = 14
const HEADER_VPAD = 4
const CATEGORY_BORDER = '1px solid rgba(0,0,0,0.08)'
const ROW_BORDER = '1px solid rgba(0,0,0,0.06)'
const HEADER_BORDER = '1px solid rgba(0,0,0,0.08)'
const HEADER_COLOR = '#9a9a9a'

const statsTableStyles = () => ({
  container: {
    overflowX: 'auto',
    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
    borderRadius: 4,
    backgroundColor: '#fff',
  },
  groupHeaderRow: {
    backgroundColor: '#fff',
  },
  leafHeaderRow: {
    backgroundColor: '#fff',
  },
  groupHeaderCell: {
    color: HEADER_COLOR,
    fontWeight: 400,
    fontSize: 13,
    lineHeight: 0,
    letterSpacing: 0.2,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    padding: 0,
    border: 'none',
    verticalAlign: 'bottom',
  },
  groupHeaderEmptyCell: {
    border: 'none',
    padding: 0,
  },
  leafHeaderCell: {
    color: HEADER_COLOR,
    fontWeight: 400,
    fontSize: 13,
    lineHeight: 1.2,
    letterSpacing: 0.2,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    padding: `0px ${HPAD}px ${HEADER_VPAD}px`,
    borderBottom: HEADER_BORDER,
    borderLeft: 'none',
    borderRight: 'none',
    borderTop: 'none',
  },
  leftHeaderCell: {
    color: HEADER_COLOR,
    fontWeight: 400,
    fontSize: 13,
    lineHeight: 1.2,
    letterSpacing: 0.2,
    whiteSpace: 'nowrap',
    padding: `0px ${HPAD}px ${HEADER_VPAD}px`,
    borderBottom: HEADER_BORDER,
    borderLeft: 'none',
    borderRight: 'none',
    borderTop: 'none',
    '&&': {
      verticalAlign: 'bottom',
    },
  },
  cell: {
    fontSize: 14,
    fontWeight: 500,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    padding: `${VPAD}px ${HPAD}px`,
    borderLeft: 'none',
    borderRight: 'none',
    borderTop: 'none',
    borderBottom: ROW_BORDER,
    color: '#222',
  },
  leftCell: {
    fontSize: 14,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    padding: `${VPAD}px ${HPAD}px`,
    borderLeft: 'none',
    borderRight: 'none',
    borderTop: 'none',
    borderBottom: ROW_BORDER,
    color: '#222',
  },
  teamCell: {
    fontSize: 14,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    padding: `${VPAD}px ${HPAD}px`,
    borderLeft: 'none',
    borderRight: 'none',
    borderTop: 'none',
    borderBottom: ROW_BORDER,
    color: '#222',
  },
  categoryBorderLeft: {
    borderLeft: CATEGORY_BORDER,
  },
  teamCellInner: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 10,
  },
  teamLogo: {
    width: 24,
    height: 24,
    objectFit: 'contain',
  },
  summaryRow: {
    backgroundColor: 'rgba(0,0,0,0.025)',
  },
  summaryLabel: {
    fontWeight: 700,
    fontSize: 14,
    color: '#222',
  },
  sectionHeading: {
    fontSize: 18,
    fontWeight: 700,
    margin: `${VPAD + 6}px 0 ${VPAD - 4}px 4px`,
  },
  gameStatsHeaderRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    flexWrap: 'wrap',
  },
  stageToggle: {
    marginLeft: 'auto',
  },
  stageToggleButton: {
    '&&': {
      color: COLORS.orange,
      padding: '4px 12px',
      border: `1px solid ${COLORS.orange}`,
      backgroundColor: COLORS.white,
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  stageToggleButtonSelected: {
    '&&': {
      backgroundColor: COLORS.lightOrange,
      '&:hover': {
        backgroundColor: COLORS.lightOrange,
      },
    },
  },
})

export default statsTableStyles
